module.exports = __webpack_public_path__ + "media/blue-truck.db9077e3.svg";